const $window = $(window);
let $activeSection;
// console.log('hello there');
/**
 * Helper function to initialize article scroll depth only for
 * specific article types
 *
 */
export function trackSectionScrollDepth($section) {
  $activeSection = $section;
  //const mediaType = $section.data('media-type'),
  //  trackMediaTypes = ['none'];

  //if (trackMediaTypes.indexOf(mediaType) === -1) return;

  const $articleBody = $section.find('.m1-newsfeed_grid');
//   console.log($articleBody, $section);

  let initial = true;

  $window.on('scroll.article-scroll-depth', (event) => {
    const sectionBox = $articleBody[0].getBoundingClientRect();

    var value = 0;

    if (sectionBox.bottom < 0) {
      value = 1;
    } else {
      value = (sectionBox.bottom - window.innerHeight) / sectionBox.height;
    }

    if (value < 0) {
      value = 0;
    }

    const valuePercent = 100 - value * 100;

    trackSectionScrolled(valuePercent, initial);

    initial = false;
  });
  // $section.on('ms-section-scrolled', trackSectionScrolled);
}

/**
 * Helper function to track article scroll depth
 */
function trackSectionScrolled(value, initial = false) {
  const lastTrackedScroll = $activeSection.data('lastTrackedScroll') || 0,
    scrollLogStep = 25;

  let tempScrolled = initial ? Math.floor(value / 10) * 10 - 10 : 0;

  while (tempScrolled < 100 && value >= tempScrolled) {
    tempScrolled += scrollLogStep;

    if (tempScrolled <= lastTrackedScroll) {
      continue;
    } else if (tempScrolled > value) {
      break;
    }

    // console.log(tempScrolled);

    if ('gtmDataLayer' in window) {
      gtmDataLayer.push({
        event: 'ArticleScrollDepth',
        ArticleScrollDepthValue: tempScrolled,
      });
    }

    $activeSection.data('lastTrackedScroll', value);

    $window.trigger('ms-scroll-depth', [tempScrolled]);
  }

  if (value >= 100) {
    // $activeSection.off('ms-section-scrolled', trackSectionScrolled);
    $window.off('scroll.article-scroll-depth');
  }
}
